// import Vue from 'vue';
import VueJwtDecode from 'vue-jwt-decode'
import axiosProtoype from '@/plugins/axios';
import router from '@/plugins/router';

export default {
    namespaced: true,
    state: {
        jwt: null,
    },
    getters: {
        getJwt(state) {
            return state.jwt;
        },
    },
    mutations: {
        setJwt(state, jwt) {
            state.jwt = jwt;
            axiosProtoype.setHeader(jwt);
        },
    },
    actions: {
        verifyJwt: ({commit, getters}, next) => {
            if (getters.getJwt !== null) {
                let decodedJwt = VueJwtDecode.decode(getters.getJwt);
                const tiempo = decodedJwt.exp - Math.round(Date.now() / 1000);
                // if (tiempo < 600) {
                if (tiempo < 0) {

                    if (tiempo < 0) {
                        commit('setJwt', null);
                        router.push('/login').catch(() => {
                        });
                    }
                } else {
                    if (next != null) {
                        next();
                    }
                }
            } else {
                commit('setJwt', null);
                router.push('/register').catch(() => {
                });
            }

        },
    },
}